<template>
    <div class="modal fade" id="change-location-modal" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content" style="min-height: 600px;">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span>Ändra lokal </span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal">
                        <span><b>x</b></span>
                    </button>
                </div>
                <div class="modal-body pb-5">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{transEdit('location')}}</label>
                                <vue-multiselect v-model="selectedLocation" :options="filterLocations" :max-height="130" label="address" placeholder="Välj lokal" open-direction="below"></vue-multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{transEdit('start')}}</label>
                                <input type="date" class="form-control" name="period_start" id="period_start" autocomplete="off">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{transEdit('end')}}</label>
                                <input type="date" class="form-control"  name="period_end" id="period_end" autocomplete="off">
                            </div>
                        </div>
                    </div>
                    <div class="row pb-20">
                        <div class="col-md-6">
                            <div>
                                <span v-if="loading"><i class="fa fa-spin fa-fw fa-refresh"></i> {{transEdit('loading')}}...</span>
                            </div>
                            <div class="text-danger">
                                <span v-if="error">{{transEdit('admin.schedules.create.conflicts-exist')}}</span>
                            </div>
                            <input class="hidden" id="change-location-modal-batch-hidden" v-model-inject="batch_id" @change="getLocations($event.target.value)">
                            <input class="hidden" id="change-location-modal-date">
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary"
                            v-on:click="updateLocation"><i class="fa fa-pencil"></i> Ändra lokal</button>
                    <button class="btn btn-dark"
                            data-dismiss="modal"><i class="fa fa-ban"></i>  {{transEdit('cancel')}}</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import VueMultiselect from "vue-multiselect/src/Multiselect";
    export default {
        name: "admin-schedules-batch-modal-change-location",
        components: {VueMultiselect},

        data() {
            return {
                locations: [],
                selectedLocation: null,
                loading: false,
                error: false,
                batch_id: null,
            }
        },
        computed: {
            filterLocations() {
                let simplifiedLocations = [];
                if(this.locations){
                    this.locations.forEach((location) => {
                        let tempAddressString = location.name +' - ' + location.city.name + ' ' + location.address;
                        simplifiedLocations.push({
                            id: location.id,
                            address: tempAddressString,
                        });
                    });
                }

                return simplifiedLocations;
            },
        },
        methods: {
            getLocations(batch) {
                this.loading = true;
                axios.get('adminschedule/batch/locations?batch_id=' + batch).then((res) => {
                    this.locations = res.data;
                    this.loading = false;
                });
            },
            updateLocation: function () {
                this.error = false;
                let thisModal = $("#change-location-modal");

                axios.post(this.$portalUrl('adminschedule/batch/changelocation'), {
                    batch_id: this.batch_id,
                    location_id: this.selectedLocation ? this.selectedLocation.id : null,
                    current_date: $("#change-location-modal-date").val(),
                    start: $("#period_start").val(),
                    end: $("#period_end").val(),
                }).then((res) => {
                    this.loading = false;
                    this.$emit('refresh');
                    thisModal.modal('toggle');
                }).catch((res) => {
                    this.error = true;
                });
            },

            getTreatmentIds() {
                if(!this.selectedTreatment || !this.selectedTreatment.length) return [];
                let ids = [];
                for(let treatment of this.selectedTreatment) {
                    ids.push(treatment.id);
                }

                return ids;
            }
        },
        watch: {
            'batch_id': function(val, oldVal){
                this.getLocations(val);
                this.loading = false;
            }
        },
        mounted() {
            this.loading = true;
        }
    }
</script>

<style scoped>

</style>
